import { useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { FaEnvelope, FaLock, FaTimes } from "react-icons/fa";
import { auth } from "../firebase";
import "../App.css";

function Login({ closeLogin, initialMode = "login", onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignup, setIsSignup] = useState(initialMode === "signup");

  const getAuthErrorMessage = (error) => {
    switch (error.code) {
      case "auth/invalid-credential":
      case "auth/user-not-found":
      case "auth/wrong-password":
        return "Invalid email or password. Please check your details or create a new account.";
      case "auth/email-already-in-use":
        return "This email is already registered. Please login instead.";
      case "auth/weak-password":
        return "Password should be at least 6 characters.";
      case "auth/invalid-email":
        return "Please enter a valid email address.";
      default:
        return error.message;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedEmail = email.trim();

    try {
      if (isSignup) {
        await createUserWithEmailAndPassword(auth, trimmedEmail, password);
        alert("Signup successful");
      } else {
        await signInWithEmailAndPassword(auth, trimmedEmail, password);
        alert("Login successful");
      }

      onLoginSuccess();
    } catch (error) {
      alert(getAuthErrorMessage(error));
    }
  };

  return (
    <div className="login-overlay">
      <div className="login-box">
        <button className="close-btn" type="button" onClick={closeLogin}>
          <FaTimes />
        </button>

        <h1>{isSignup ? "Create Account" : "Welcome Back"}</h1>

        <p className="login-subtitle">
          {isSignup ? "Create an account to continue shopping" : "Login to continue shopping"}
        </p>

        <form onSubmit={handleSubmit}>
          <div className="input-box">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              placeholder="Enter Email"
              value={email}
              required
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>

          <div className="input-box">
            <FaLock className="input-icon" />
            <input
              type="password"
              placeholder="Enter Password"
              value={password}
              required
              minLength={6}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          <button type="submit" className="login-btn">
            {isSignup ? "Create Account" : "Login"}
          </button>
        </form>

        <p className="switch-auth">
          {isSignup ? "Already have an account?" : "Don't have an account?"}
          <span onClick={() => setIsSignup((currentValue) => !currentValue)}>
            {isSignup ? " Login" : " Signup"}
          </span>
        </p>
      </div>
    </div>
  );
}

export default Login;
